import React from 'react';
import { Box, Typography, Grid, Card, CardContent } from '@mui/material';
import PsychologyAltOutlinedIcon from '@mui/icons-material/PsychologyAltOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';

const benefitCards = [
  {
    icon: <PsychologyAltOutlinedIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />,
    title: 'Understand Yourself Deeply',
    desc: 'Go beyond surface-level self-help. CYJ guides you to real insight and emotional clarity.'
  },
  {
    icon: <AutoAwesomeOutlinedIcon sx={{ fontSize: 40, color: 'custom.red', mb: 1 }} />,
    title: 'Break Free from Limiting Beliefs',
    desc: 'Release old stories and patterns that keep you stuck, and build new habits for peace.'
  },
  {
    icon: <FavoriteBorderOutlinedIcon sx={{ fontSize: 40, color: 'custom.blue', mb: 1 }} />,
    title: 'Design a Life That Feels True',
    desc: 'Shape your days around your values, strengths, and what truly matters to you.'
  },
];

const packageCards = [
  {
    icon: <MenuBookOutlinedIcon sx={{ fontSize: 36, color: 'primary.main', mb: 1 }} />,
    label: 'Structured Journal (65 Pages)',
    desc: 'Your space for reflection, release, and rebuilding.'
  },
  {
    icon: <LibraryBooksOutlinedIcon sx={{ fontSize: 36, color: 'custom.red', mb: 1 }} />,
    label: 'Deep 158-Page Guide',
    desc: 'Step-by-step support, science-based, and deeply practical.'
  },
  {
    icon: <AssessmentOutlinedIcon sx={{ fontSize: 36, color: 'custom.blue', mb: 1 }} />,
    label: 'Personal Assessments',
    desc: 'Science-based tools for self-understanding.'
  },
];

const WhatIsCYJ = () => (
  <Box sx={{ bgcolor: 'custom.blue', py: { xs: 4, md: 6 }, px: { xs: 1, md: 0 } }}>
    <Box sx={{ maxWidth: 1100, mx: 'auto' }}>
      <Typography variant="h2" sx={{ color: 'text.main', mb: 2, textAlign: 'center', fontFamily: 'Just Another Hand' }}>
        What is CYJ?
      </Typography>
      <Typography sx={{ mb: 4, color: 'text.secondary', textAlign: 'center', fontSize: { xs: 16, md: 18 } }}>
        CYJ – Self-Discovery Package is a complete guided experience rooted in Positive Psychology that helps you:
      </Typography>
      <Grid container spacing={3} justifyContent="center" sx={{ mb: 4 }}>
        {benefitCards.map((item, idx) => (
          <Grid item xs={12} sm={6} md={4} key={item.title}>
            <Card elevation={3} sx={{ borderRadius: 3, p: 2, height: '100%', bgcolor: 'background.paper', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>{item.icon}</Box>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>{item.title}</Typography>
                <Typography sx={{ color: 'text.secondary', fontSize: 16 }}>{item.desc}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Typography sx={{ mb: 2, color: 'text.secondary', textAlign: 'center', fontWeight: 500 }}>
        This package is a full journey with:
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {packageCards.map((item, idx) => (
          <Grid item xs={12} sm={6} md={4} key={item.label}>
            <Card elevation={2} sx={{ borderRadius: 3, p: 2, height: '100%', bgcolor: 'custom.beige', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>{item.icon}</Box>
              <CardContent>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>{item.label}</Typography>
                <Typography sx={{ color: 'text.secondary', fontSize: 15 }}>{item.desc}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  </Box>
);

export default WhatIsCYJ;
